import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Theme from 'components/common/Theme/Theme'
import Modal from 'components/common/Modal'
import Button from 'components/common/Button/Button'

const FilterModal = ({
  children,
  handleHide,
  handleSubmit
}) =>
  <CustomModal title="Filter Results" closeHandler={ handleHide }>
    { children }
    <ButtonWrapper>
      <Button full narrow data-at-filter-results-button onClick={ handleSubmit }>View Updated Results</Button>
    </ButtonWrapper>
  </CustomModal>

export default FilterModal

FilterModal.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  handleHide: PropTypes.func,
  handleSubmit: PropTypes.func
}

const CustomModal = styled(Modal)`
  && {
    padding: 0 0 80px 0;
  }
`

const ButtonWrapper = styled.div`
  position: fixed;
  z-index: 30;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 20px 16px;
  background-color: ${Theme.colors.white};
  box-shadow: 0 -1px 4px -2px ${Theme.colors.black};
`
